"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Dropdown = require("./Dropdown.styles");

var _DropdownMenuItem = _interopRequireDefault(require("./DropdownMenuItem"));

var _Dropdown2 = require("./Dropdown.provider");

var _elements = require("../../styles/elements");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Menu = (0, _base["default"])("ul", {
  target: "e1wygoc30",
  label: "Menu"
})(process.env.NODE_ENV === "production" ? {
  name: "1nob2mz",
  styles: "&:focus{outline:none;}"
} : {
  name: "1nob2mz",
  styles: "&:focus{outline:none;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var DropdownMenu = function DropdownMenu(_ref) {
  var className = _ref.className,
      children = _ref.children,
      as = _ref.as;

  var _useContext = (0, _react.useContext)(_Dropdown2.DropdownContext),
      emptyHint = _useContext.emptyHint;

  var childrenArray = _react["default"].Children.toArray(children);

  if (childrenArray.length) {
    return (0, _jsxRuntime.jsx)(Menu, {
      tabIndex: 0,
      role: "menu",
      css: _elements.list.styles.preflight,
      className: className,
      as: as,
      children: children
    });
  } // Empty menu


  return (0, _jsxRuntime.jsx)("div", {
    css: [_Dropdown.styles.item, _elements.text.styles.italic, _elements.text.styles.textMediumDark, process.env.NODE_ENV === "production" ? "" : ";label:DropdownMenu;"],
    className: "grui py-5",
    children: emptyHint
  });
};

DropdownMenu.propTypes = {
  className: _propTypes.string,
  children: _propTypes.node,
  as: _propTypes.elementType
};
DropdownMenu.defaultProps = {
  className: undefined,
  children: undefined,
  as: 'ul'
};
DropdownMenu.Item = _DropdownMenuItem["default"];
var _default = DropdownMenu;
exports["default"] = _default;
//# sourceMappingURL=DropdownMenu.js.map